import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import { DEFAULT_LANG } from "utils/constants/keys";
import { getCachedConfiguration } from "utils/functions/configurationUtil";
import defaultTranslation from "./assets/locales/en-us.json";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: DEFAULT_LANG,
    lng: DEFAULT_LANG,
    lowerCaseLng: true,
    resources: {
      [DEFAULT_LANG]: { translation: defaultTranslation },
    },
  })
  .then(() => {
    const configuration = getCachedConfiguration();
    const storedLanguage = configuration?.language || DEFAULT_LANG;
    loadTranslationResource(storedLanguage);
  });

export const loadTranslationResource = (language: string) => {
  const normalizedLanguage = language.toLowerCase();

  if (i18n.hasResourceBundle(normalizedLanguage, "translation")) {
    return i18n.changeLanguage(normalizedLanguage);
  }

  return import(`./assets/locales/${normalizedLanguage}.json`)
    .then((translation) => {
      i18n.addResourceBundle(normalizedLanguage, "translation", translation.default);
      return i18n.changeLanguage(normalizedLanguage);
    })
    .catch((error) => {
      console.error(`Failed to load translations for "${normalizedLanguage}":`, error);
      return i18n.changeLanguage(DEFAULT_LANG);
    });
};

export default i18n;
